// extracted by mini-css-extract-plugin
export var background = "storeHero-module--background--OTuGe";
export var buttonContainer = "storeHero-module--buttonContainer--pn30W";
export var heading = "storeHero-module--heading--4vAoJ";
export var image = "storeHero-module--image--s3NvW";
export var section = "storeHero-module--section--1GWLh";
export var show = "storeHero-module--show--Pgtzq";
export var subheading = "storeHero-module--subheading--DXpkO";